"use strict";

define('view/table.selected.add',['require','exports','module','uikit/uikit','./table.selected.view','langs'],function (require, exports, module) {
  var UIKit = require('uikit/uikit');
  var TableSelectedView = require('./table.selected.view');
  var langs = require('langs');
  var TableSelectedAdd = TableSelectedView.extend({
    internalViews: {
      view: UIKit.Button
    },
    internalViewOptions: {
      view: function view() {
        var ariaLabel = langs.phrase('ReportingPage.Details.ColumnOptions.AddButton.ARIALabel.Prefix') + this.model.get('displayName');
        return {
          circular: true,
          icon: 'plus',
          size: 'mini',
          className: UIKit.Button.prototype.className + ' invertable',
          role: 'menuitem',
          ariaLabel: ariaLabel
        };
      }
    },
    initialize: function initialize() {
      TableSelectedView.prototype.initialize.apply(this, arguments);
      this.view.on('press', function () {
        var row = this.getRow();
        row.trigger('add', this);
      }, this);
    }
  });
  module.exports = TableSelectedAdd;
});

